import { render, staticRenderFns } from "./SpecPopupDsCardCoupons.vue?vue&type=template&id=8db01f44&scoped=true&"
import script from "./SpecPopupDsCardCoupons.vue?vue&type=script&lang=js&"
export * from "./SpecPopupDsCardCoupons.vue?vue&type=script&lang=js&"
import style0 from "./SpecPopupDsCardCoupons.vue?vue&type=style&index=0&id=8db01f44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db01f44",
  null
  
)

export default component.exports